export enum GeneralPermissions {
  viewDashboard = "view_dashboard",
}

export enum AggregatorsPermissions {
  addAgg = "add_aggregator",
  addAggCostFee = "add_aggregator_cost_and_fee",
}

export enum OCPermissions {
  // summary
  viewOCSummary = "view_operation_cost_summary",
  // list
  viewOCList = "view_operation_cost",
  addOC = "add_operation_cost",
  editOC = "edit_operation_cost",
  deleteOC = "delete_operation_cost",
  payOC = "pay_operation_cost",
  //accounts
  viewOCAccounts = "view_accounts",
  addOCAccount = "add_account",
  editOCAccount = "edit_account",
  deleteOCAccount = "delete_account",
  changeOCAccountStatus = "change_account_status",
  //vendors
  viewVendors = "view_vendors",
  addVendor = "add_vendor",
  editVendor = "edit_Vendor",
  deleteVendor = "delete_Vendor",
  // expenses bills
  viewBills = "view_bills",
  addBill = "add_bill",
  editBill = "edit_bill",
  deleteBill = "delete_bill",
}

// Fixed Assets
export enum FixedAssetsPermissions {
  viewFixedAssetsSummary = "view_fixed_assets_summary",
  // categories
  viewFixedAssetCategories = "view_fixed_asset_categories",
  addFixedAssetCategory = "add_fixed_asset_category",
  editFixedAssetCategory = "edit_fixed_asset_category",
  deleteFixedAssetCategory = "delete_fixed_asset_category",
  // assets
  viewFixedAssets = "view_fixed_assets",
  addFixedAsset = "add_fixed_asset",
  editFixedAsset = "edit_fixed_asset",
  deleteFixedAsset = "delete_fixed_asset",
  // assets bills
  viewFixedAssetBills = "view_fixed_asset_bills",
  addFixedAssetBill = "add_fixed_asset_bill",
  editFixedAssetBill = "edit_fixed_asset_bill",
  deleteFixedAssetBill = "delete_fixed_asset_bill",
}

export enum PurchasingPermissions {
  // summary
  viewSummary = "view_purchase_summary",
  // purchasing list
  viewPurchasingList = "view_purchases",
  addPurchasing = "add_purchase",
  editPurchasing = "edit_purchase",
  deletePurchasing = "delete_purchase",
  payPurchasing = "pay_purchase",
  //suppliers
  viewSupplier = "view_suppliers",
  addSupplier = "add_supplier",
  editSupplier = "edit_supplier",
  deleteSupplier = "delete_supplier",
}

export enum EventsPermissions {
  // owner events
  addOwnerEvent = "add_owner_event",
  deleteOwnerEvent = "delete_owner_event",
  // supplier events
  addSupplierEvent = "add_supplier_event",
  deleteSupplierEvent = "delete_supplier_event",
  // payment events
  addPaymentEvent = "add_payment_event",
  deletePaymentEvent = "delete_payment_event",
  // fixed asset events
  viewFixedAssetEvent = "view_fixed_asset_event",
  addFixedAssetEvent = "add_fixed_asset_event",
  deleteFixedAssetEvent = "delete_fixed_asset_event",
  // inventory events
  viewInventoryEvent = "view_inventory_event",
  addInventoryEvent = "add_inventory_event",
  deleteInventoryEvent = "delete_inventory_event",
  // vendor events
  addVendorEvent = "add_vendor_event",
  deleteVendorEvent = "delete_vendor_event",
  // other revenue events
  addOtherRevenueEvent = "add_other_revenue_event",
  deleteOtherRevenueEvent = "delete_other_revenue_event",
  // client events
  addClientEvent = "add_client_event",
  deleteClientEvent = "delete_client_event",
  // expense events
  addExpenseEvent = "add_expense_event",
  deleteExpenseEvent = "delete_expense_event",
  // employee events
  addEmployeeEvent = "add_employee_event",
  deleteEmployeeEvent = "delete_employee_event",
}

export enum SettingsPermissions {
  // branch list
  viewBranches = "view_branches",
  addBranch = "add_branch",
  editBranch = "edit_branch",
  changeBranchStatus = "change_branch_status",
  companyLockDate = "company_lock_date",
  branchLockDate = "branch_lock_date",
  //users
  viewUsers = "view_users",
  addUser = "add_user",
  editUser = "edit_user",
  deleteUser = "delete_user",
  //roles
  viewRole = "view_roles",
  addRole = "add_role",
  editRole = "edit_role",
  deleteRole = "delete_role",
  // payments list
  viewPaymentList = "view_payment_methods",
  addPayment = "add_payment_method",
  editPayment = "edit_payment_method",
  deletePayment = "delete_payment_method",
  changePaymentStatus = "change_payment_method_status",
  // payments transactions
  viewPaymentTransactions = "view_payment_transactions",
  //capital
  viewCapitals = "view_capitals",
  addCapital = "add_capital",
  editCapital = "edit_capital",
  deleteCapital = "delete_capital",
}

export enum MenuPermissions {
  // products
  viewProducts = "view_products",
  addProduct = "add_product",
  AddProductRecipe = "add_product_recipe",
  editProduct = "edit_product",
  deleteProduct = "delete_product",
  // modifiers
  viewModifiers = "view_modifiers",
  addModifier = "add_modifier",
  AddModifierRecipe = "add_modifier_recipe",
  editModifier = "edit_modifier",
  deleteModifier = "delete_modifier",
  // categories
  viewCategories = "view_categories",
  addCategory = "add_category",
  editCategory = "edit_category",
  deleteCategory = "delete_category",
}

export enum SalesPermissions {
  // sales list
  viewSales = "view_sales",
  addSale = "add_sales",
  editSale = "edit_sales",
  deleteSale = "delete_sales",
  // products sales
  viewProductSales = "view_product_sales",
  // modifiers sales
  viewModifierSales = "view_modifier_sales",
  // sales invoices
  viewSaleInvoices = "view_sale_invoices",
  addSaleInvoice = "add_sale_invoice",
  returnSaleInvoice = "return_sale_invoice",
  paySaleInvoice = "pay_sale_invoice",
  // clients
  viewClients = "view_clients",
  addClient = "add_client",
  editClient = "edit_client",
  deleteClient = "delete_client",
}

export enum InventoryPermissions {
  // summary
  viewSummary = "view_inventory_summary",
  // items list
  viewItems = "view_items",
  addItem = "add_item",
  editItem = "edit_item",
  deleteItem = "delete_item",
  // Unit cost Adjustment
  viewUnitCostAdjustments = "view_unit_cost_adjustments",
  addUnitCostAdjustment = "manage_unit_cost_adjustment",
  //stocktaking
  viewStocktaking = "view_stocktaking",
  addStocktaking = "add_stocktaking",
  deleteStocktaking = "delete_stocktaking",
  confirmStocktaking = "confirm_stocktaking",
  deleteConfirmedStocktaking = "delete_confirm_stocktaking",
  //waste formula
  viewWasteFormulas = "view_waste_formulas",
  addWasteFormula = "add_waste_formula",
  editWasteFormula = "edit_waste_formula",
  deleteWasteFormula = "delete_waste_formula",
  // level
  viewLevel = "view_level",
  // COGS
  viewCogs = "view_cogs",
  addCogs = "add_cogs",
  editCogs = "edit_cogs",
  deleteCogs = "delete_cogs",
  // transfers
  viewTransfers = "view_transfers",
  addTransfer = "add_transfer",
  confirmTransfer = "confirm_transfer",
  deleteTransfer = "delete_transfer",
  sendTransfer = "send_transfer",
  deleteConfirmedTransfer = "delete_confirmed_transfer",
  // production
  viewPro = "view_pro",
  addPro = "add_pro",
  editPro = "edit_pro",
  deletePro = "delete_pro",
  createProEntry = "create_pro_entry",
  deleteProEntry = "delete_pro_entry",
  // reorder
  viewReorder = "view_reorder",
  approveOrCancelReorder = "approve_cancel_reorder",
  sendReorder = "send_reorder",
  viewPoReq = "view_po_requests",
  cancelPoReq = "cancel_po_request",
  sendPoReq = "send_po_request",
}

// Third Eye Reports
export enum ReportsPermissions {
  viewThirdEyeReportFinancialStatements = "view_third_eye_report_financial_statements",
  viewThirdEyeReportDeliveryApps = "view_third_eye_report_delivery_apps",
  viewThirdEyeReportSales = "view_third_eye_report_sales",
  viewThirdEyeReportAccounting = "view_third_eye_report_accounting",
  viewThirdEyeReportOperationExpenses = "view_third_eye_report_operation_expenses",
  viewThirdEyeReportPurchasing = "view_third_eye_report_purchasing",
  viewThirdEyeReportInventory = "view_third_eye_report_inventory",
}

export enum ForAccountantPermissions {
  // chart od accounts
  viewChartOfAccounts = "view_chart_of_accounts",
  addChartOfAccount = "add_chart_of_account",
  editChartOfAccount = "edit_chart_of_account",
  deleteChartOfAccount = "delete_chart_of_account",
  // manual journal
  viewManualJournals = "view_manual_journals",
  addManualJournal = "add_manual_journal",
  editManualJournal = "edit_manual_journal",
  deleteManualJournal = "delete_manual_journal",
  // Journal Entries
  viewJournalEntries = "view_journal_entries",
  // Audit Trail
  viewAuditTrail = "view_audit_trail",
  // auditing
  viewAuditing = "view_auditing",
  manageAuditing = "manage_auditing",
  // Reconciliation
  viewAggregators = "view_aggregators",
  viewBanks = "view_banks",
  manageAggregators = "manage_aggregators",
  manageBanks = "manage_banks",
}

export enum IntegrationsPermissions {
  viewIntegration = "view_integration",
  connectIntegration = "connect_integration",
}
